var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIconUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12.2654 7 12.5067 7.09408 12.6997 7.28225L18.7315 13.3976C19.0934 13.7739 19.0934 14.3619 18.7074 14.7383C18.3214 15.0911 17.7182 15.0911 17.3321 14.7147L12 9.30501L6.66785 14.7147C6.30594 15.0911 5.67864 15.0911 5.2926 14.7383C4.90657 14.3855 4.9066 13.7739 5.26851 13.3976L11.3003 7.28225C11.4933 7.09408 11.7346 7 12 7Z",
    fill: "#2C3D50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconUp);
export default __webpack_public_path__ + "static/media/arrow_icon_up.6ef3e2acfce4a2f32ce701cc1f913afa.svg";
export { ForwardRef as ReactComponent };